"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ark = require("@dateam/ark");
var _arkReact = require("@dateam/ark-react");
const CalendarDay = _ref => {
  let {
    date,
    selected,
    disabled,
    onClick
  } = _ref;
  const click = _react.default.useCallback(event => (0, _ark.isFunction)(onClick) && onClick(date, event), [date, onClick]);
  const day = date.getDate();
  return /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _arkReact.concatClassName)('calendarDay', disabled ? 'calendarDayMuted' : null, selected ? 'calendarDaySelected' : null),
    onClick: click
  }, day);
};
process.env.NODE_ENV !== "production" ? CalendarDay.propTypes = {
  date: _propTypes.default.instanceOf(Date).isRequired,
  selected: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func
} : void 0;
CalendarDay.defaultProps = {
  selected: false,
  disabled: false,
  onClick: undefined
};
var _default = exports.default = CalendarDay;